import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { Container } from "react-bootstrap";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import OfflineExamResultsSection from '../components/offlineExamResults/offlineExamResultsSection'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";


const GET_EXAM_PAPERS = gql`
query($institute_id:Int){
    getOfflineExamPapers(institute_id: $institute_id) {
     paper_name
        class_id
        exam_id
        branch_id
        section_id
        exam_paper_id
        exam_date
      }
}
`

class OfflineExamResults extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {

        const getOfflineExamPapers = this.props.getOfflineExamPapers
        const loading = getOfflineExamPapers.loading;
        const error = getOfflineExamPapers.error

        if (error !== undefined) {
            alert("Server Error. " + error.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <Container fluid>
                            {
                                loading ?
                                    (<div className="spinner-border text-primary text-center loading-img-center" ></div>
                                    )
                                    :
                                    (<OfflineExamResultsSection
                                        getOfflineExamPapers={getOfflineExamPapers.getOfflineExamPapers}
                                    />)
                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(GET_EXAM_PAPERS, {
        options: (props) => ({
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "getOfflineExamPapers",
    }),
)(OfflineExamResults))
);